export function getRelativePath({ path, instance }) {
  return path.replace(`${instance.name}/`, '');
}
